import { RollingDateOptionsOrdered } from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateOptionsOrdered';
import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
import { restrictedAsset, wrapWithRestrictedAssetTooltip } from '../utils/fieldLevelPermissionsUtilsForQuickFilters';
import { useMemo } from 'react';
import I18n from 'I18n';
import InRollingDateRange from 'customer-data-filters-ui/filterQueryFormat/operator/InRollingDateRange';
import RollingDateConfig from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateConfig';
import QuickFilterSelectBase from './QuickFilterSelectBase';
import QuickFilterTooltip from './QuickFilterTooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Select } from 'foundations-components/transitional/components/Select';
import { useQuickFilterOpenState } from './hooks/useQuickFilterOpenState';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const getRollingDateOptions = () => {
  return RollingDateOptionsOrdered.map(({
    helpToken,
    textToken,
    value
  }) => ({
    help: I18n.text(helpToken),
    text: I18n.text(textToken),
    value
  }));
};
const getValueFromCondition = condition => {
  if (!condition) {
    return undefined;
  }
  return RollingDateConfig.toRollingDateOptionValue(condition.value);
};
const DatetimeQuickFilter = ({
  buttonProperties,
  condition,
  disableTruncation,
  isFirst,
  property,
  onValueChange
}) => {
  const {
    isOpen,
    onToggleOpen
  } = useQuickFilterOpenState(property.name);
  const options = useMemo(getRollingDateOptions, []);
  const value = useMemo(() => getValueFromCondition(condition), [condition]);
  const isActive = !!value;
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const onDateValueChange = evt => {
    const newRollingDateConfig = RollingDateConfig.fromRollingDateOptionValue(evt.target.value);
    if (newRollingDateConfig) {
      onValueChange(InRollingDateRange.of(property, newRollingDateConfig));
    } else {
      onValueChange();
    }
  };
  const renderButtonContent = () => {
    const baseContent = /*#__PURE__*/_jsxs(_Fragment, {
      children: [isRestrictedField && restrictedAsset, property.displayName]
    });
    if (disableTruncation) {
      const contentWithoutTruncation = /*#__PURE__*/_jsx("span", {
        children: baseContent
      });
      return isRestrictedField ? wrapWithRestrictedAssetTooltip(contentWithoutTruncation) : /*#__PURE__*/_jsx(QuickFilterTooltip, {
        condition: condition,
        property: property,
        children: contentWithoutTruncation
      });
    }
    const useTruncateStringTooltip = !isActive && !property.tooltip;
    const contentWithValue = /*#__PURE__*/_jsx(TruncateString, {
      maxWidth: buttonProperties.LABEL_MAX_WIDTH,
      tooltip: useTruncateStringTooltip && !isRestrictedField,
      children: property.displayName
    });
    return isRestrictedField ? wrapWithRestrictedAssetTooltip(contentWithValue) : /*#__PURE__*/_jsx(QuickFilterTooltip, {
      condition: condition,
      disabled: useTruncateStringTooltip,
      property: property,
      children: contentWithValue
    });
  };
  return /*#__PURE__*/_jsx(QuickFilterSelectBase, {
    propertyName: property.name,
    button: /*#__PURE__*/_jsx(Select, {
      ButtonContent: renderButtonContent,
      buttonSize: buttonProperties.BUTTON_SIZE,
      buttonUse: buttonProperties.BUTTON_USE,
      disabled: isRestrictedField || property.disabled,
      menuWidth: "auto",
      onChange: onDateValueChange,
      onOpenChange: onToggleOpen,
      open: isOpen,
      options: options,
      placement: isFirst ? 'bottom right' : 'bottom',
      value: value
    }),
    buttonHeight: buttonProperties.BUTTON_HEIGHT,
    isActive: isActive,
    onValueChange: onValueChange
  });
};
export default DatetimeQuickFilter;